/* eslint-disable functional/no-expression-statement */
import { Reference } from "~/Data";
import * as Driver from "~/Driver";
import * as Log from "~/Log";
import { Time } from "~/Time";

/**
 * A `Suggestion` only exists while creating a new `Revision`. If submitted
 * and saved, it becomes a `Revision`.
 */
export type Suggestion = Log.Revision.Revision & {
  readonly event?: Reference.Reference;
};

export const create = (log: Log.Identity): Suggestion => ({
  id: `new-${log.driver.id}`,
  driver: log.driver,
  status: Driver.Status.on(),
  location: "",
  sources: { current: Log.Event.Source.revision() },
  ...Time.DateTime.toDayInterval(log),
});

export const canEditWork = ({ status }: Partial<Suggestion>): boolean =>
  status === Driver.Status.personalUse() || status !== Driver.Status.off();

